<div class="ion-content" [ngClass]="{'is-mobile': isMobile, 'is-browser': isBrowser}">
  <div class="logo-container">
    <div class="flex-row">
      <div class="logo"></div>
      <div class="logo-text">
        <p class="h1">Promo
          <span *ngIf="isBuildDev" class="dev-label">dev</span>
          <span *ngIf="isBuildStage" class="stage-label">stage</span>
        </p>
        <p class="h1">Portal
          <span class="ver">v.{{appVersion}}</span>
        </p>
      </div>
    </div>
  </div>

  <form [formGroup]="loginForm"
        (submit)="onSubmit()"
        class="auth-content"
        [ngClass]="{'form-error': isFormError, 'desktop': !isDevicePlatform}">
    <div class="auth-error" *ngIf="authErrResult$ | async">
          <span *ngIf="errorBackendMsg;else defaultError">
            {{errorBackendMsg}}
          </span>
      <ng-template #defaultError>
            <span>
              Email/Password combination was not recognized.
              <br>Try again or tap Forgot Password to reset.
            </span>
      </ng-template>
    </div>

    <div class="auth-template">
      <input formControlName="email"
             type="email"
             [placeholder]="'Email'"
             class="auth-input fadeInRight delay-0s3" />

      <input formControlName="password"
             type="password"
             [placeholder]="'Password'"
             (keydown)="onKeydown($event)"
             class="auth-input fadeInLeft delay-0s5" />

      <button type="submit"
              [disabled]="loginForm.invalid || isLoggingInLoading"
              class="auth-button fadeInRight delay-0s7">
        Login
        <div class="css-loader" *ngIf="isLoggingInLoading"></div>
      </button>

      <div class="additional-buttons fadeIn delay-0s9">
        <button type="button" (click)="onForgotPassClick()">
          Forgot Password?
        </button>

        <button type="button" (click)="onRegistrationClick()">
          First time user
        </button>
      </div>
    </div>
  </form>

  <div class="footer">
    <div class="sony-music-logo fadeIn delay-1s" [ngClass]="getBrowserClass"></div>
  </div>
</div>
